import React from 'react';

import cx from 'classnames';

import { Breadcrumb } from 'components/PRISMIC/PrismicNavigation/util';
import styles from 'components/PRISMIC/scss/pages.module.scss';

const Breadcrumbs = (props: { breadcrumbs: Breadcrumb[] }) => (
  <nav className={cx(styles.breadcrumb, styles.m4, styles['show-lg'])}>
    {props.breadcrumbs.map((it, index) => (
      <React.Fragment key={index}>
        {index === 0 ? (
          it.title
        ) : (
          <a
            href={it.url || '#'}
            className={cx(styles['breadcrumb__link'], 'hover:text-[#333]')}
          >
            {it.title}
          </a>
        )}
        &nbsp;&nbsp;›&nbsp;&nbsp;
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumbs;
